import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout'
import EditContentPage from './EditContentPage'
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/messages';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.EditContentDetails);

    let id = Number(params.pageId)
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }
    // Admin restriction
    if (!restrictUrls('/siteadmin/contentpage/edit/', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }
    return {
        title,
        component: (
            <AdminLayout>
                <EditContentPage title={title} id={id} isAdmin={isAdminAuthenticated} />
            </AdminLayout>
        )
    }
}

export default action;